/** @format */

import { createBrowserRouter, Navigate } from "react-router-dom";
import { Auth } from "../pages/Auth/Loadable";
import { lazyLoad } from "../utils/loadable";
import RootLayout from "../RootLayout";

const Login = lazyLoad(
  () => import("../pages/Auth/Login/Login"),
  (module) => module.default,
  {
    fallback: <div>Loading...</div>,
  }
);
const RetailLogin = lazyLoad(
  () => import("../pages/Auth/RetailLogin"),
  (module) => module.default,
  {
    fallback: <div>Loading...</div>,
  }
);
const RetailRegister = lazyLoad(
  () => import("../pages/Auth/RetailRegister"),
  (module) => module.default,
  {
    fallback: <div>Loading...</div>,
  }
);
const Signup = lazyLoad(
  () => import("../pages/Auth/Signup/Signup"),
  (module) => module.default,
  {
    fallback: <div>Loading...</div>,
  }
);
const Home = lazyLoad(
  () => import("../pages/Home/Home"),
  (module) => module.default,
  {
    fallback: <div>Loading...</div>,
  }
);
const ProductPage = lazyLoad(
  () => import("../pages/Products/user"),
  (module) => module.ProductPage,
  {
    fallback: <div>Loading...</div>,
  }
);
const Cart = lazyLoad(
  () => import("../pages/Products/Cart/Loadable"),
  (module) => module.Cart,
  {
    fallback: <div>Loading...</div>,
  }
);

const CartList = lazyLoad(
  () => import("../pages/Products/Cart/containers/CartList"),
  (module) => module.default,
  {
    fallback: <div>Loading...</div>,
  }
);
const Category = lazyLoad(
  () => import("../pages/Products/user/Category"),
  (module) => module.default,
  {
    fallback: <div>Loading...</div>,
  }
);
const Categories = lazyLoad(
  () => import("../pages/Products/user/Category/categories"),
  (module) => module.default,
  {
    fallback: <div>Loading...</div>,
  }
);
const PackageDetail = lazyLoad(
  () => import("../pages/Products/user/PackageDetail"),
  (module) => module.default,
  {
    fallback: <div>Loading...</div>,
  }
);
const Product = lazyLoad(
  () => import("../pages/Products/user/product"),
  (module) => module.default,
  {
    fallback: <div>Loading...</div>,
  }
);
const EmailUpdate = lazyLoad(
  () => import("../pages/Profile/container/EmailUpdate"),
  (module) => module.default,
  {
    fallback: <div>Loading...</div>,
  }
);
const Notices = lazyLoad(
  () => import("../pages/Profile/container/Notices"),
  (module) => module.default,
  {
    fallback: <div>Loading...</div>,
  }
);
const ContactUs = lazyLoad(
  () => import("../pages/Contact"),
  (module) => module.ContactUsPage,
  {
    fallback: <div>Loading...</div>,
  }
);

const PrivacyPolicy = lazyLoad(
  () => import("../pages/Privacy"),
  (module) => module.default,
  {
    fallback: <div>Loading...</div>,
  }
);
const Terms = lazyLoad(
  () => import("../pages/Terms"),
  (module) => module.default,
  {
    fallback: <div>Loading...</div>,
  }
);

const News = lazyLoad(
  () => import("../pages/Products/user/news"),
  (module) => module.NewsPage,
  {
    fallback: <div>Loading...</div>,
  }
);

const Checkout = lazyLoad(
  () => import("../pages/Products/Cart/containers/checkout"),
  (module) => module.default,
  {
    fallback: <div>Loading...</div>,
  }
);
const ProductDetails = lazyLoad(
  () => import("../pages/Products/user/Details"),
  (module) => module.default,
  {
    fallback: <div>Loading...</div>,
  }
);
const ProfilePages = lazyLoad(
  () => import("../pages/Profile"),
  (module) => module.ProfilePages,
  {
    fallback: <div>Loading...</div>,
  }
);
const MemberInfo = lazyLoad(
  () => import("../pages/Profile/component/MemberInfo"),
  (module) => module.default,
  {
    fallback: <div>Loading...</div>,
  }
);
const ChangePassword = lazyLoad(
  () => import("../pages/Profile/container/ChangePassword"),
  (module) => module.default,
  {
    fallback: <div>Loading...</div>,
  }
);
const Orders = lazyLoad(
  () => import("../pages/Profile/container/Orders"),
  (module) => module.default,
  {
    fallback: <div>Loading...</div>,
  }
);
const Profile = lazyLoad(
  () => import("../pages/Profile/container/Profile"),
  (module) => module.default,
  {
    fallback: <div>Loading...</div>,
  }
);

const RetailerCategory = lazyLoad(
  () => import("../pages/Products/Retailer/container/category"),
  (module) => module.default,
  {
    fallback: <div>Loading...</div>,
  }
);
const PaymentSuccess = lazyLoad(
  () => import("../pages/Products/Cart/payment-success"),
  (module) => module.default,
  {
    fallback: <div>Loading...</div>,
  }
);
const PaymentFailed = lazyLoad(
  () => import("../pages/Products/Cart/payment-failed"),
  (module) => module.default,
  {
    fallback: <div>Loading...</div>,
  }
);
const ProductList = lazyLoad(
  () => import("../pages/Products/Retailer/container/product/list"),
  (module) => module.default,
  {
    fallback: <div>Loading...</div>,
  }
);
const RetailerProductPage = lazyLoad(
  () => import("../pages/Products/Retailer/container/product"),
  (module) => module.RetailerProductPage,
  {
    fallback: <div>Loading...</div>,
  }
);
const OrdersDetails = lazyLoad(
  () => import("../pages/Profile/container/orders-details"),
  (module) => module.default,
  {
    fallback: <div>Loading...</div>,
  }
);
const OrderUpdate = lazyLoad(
  () => import("../pages/Profile/container/order-update"),
  (module) => module.default,
  {
    fallback: <div>Loading...</div>,
  }
);

const HowToUse = lazyLoad(
  () => import("../pages/how-to-use/Loadable"),
  (module) => module.HowToUse,
  {
    fallback: <div>Loading...</div>,
  }
);

const ForgotPassword = lazyLoad(
  () => import("../pages/Auth/ForgotPassword/ForgotPassword"),
  (module) => module.default,
  {
    fallback: <div>Loading...</div>,
  }
);

const userRoute = createBrowserRouter([
  {
    path: "/",
    element: <RootLayout />,
    children: [
      { index: true, element: <Home /> },
      {
        path: "/auth",
        element: <Auth />,
        children: [
          {
            path: "login",
            element: <Login />,
          },
          {
            path: "signup",
            element: <Signup />,
          },
        ],
      },
      {
        path: "/app",
        element: "",
        children: [
          {
            path: "product",
            element: <ProductPage />,
            children: [
              {
                path: "category",
                element: <Category />,
              },
              {
                path: "category-by/:id",
                element: <Categories />,
              },
              {
                path: "products/:id",
                element: <Product />,
              },
              {
                path: "details/:id",
                element: <ProductDetails />,
              },
              {
                path: "package-details/:id",
                element: <PackageDetail />,
              },
              {
                path: "news/:id",
                element: <News />,
              },
            ],
          },
          {
            path: "cart",
            element: <Cart />,
            children: [
              {
                path: "list",
                element: <CartList />,
              },
              {
                path: "checkout",
                element: <Checkout />,
              },
              {
                path: "payment-success",
                element: <PaymentSuccess />,
              },
              {
                path: "payment-failed",
                element: <PaymentFailed />,
              },
            ],
          },
          {
            path: "profile",
            element: <ProfilePages />,
            children: [
              {
                path: "user-details",
                element: <Profile />,
              },
              {
                path: "member-info",
                element: <MemberInfo />,
              },
              {
                path: "change-email",
                element: <EmailUpdate />,
              },
              {
                path: "change-password",
                element: <ChangePassword />,
              },
              {
                path: "order",
                element: <Orders />,
              },
              {
                path: "order/:id",
                element: <OrdersDetails />,
              },
              {
                path: "order-update/:id",
                element: <OrderUpdate />,
              },
              {
                path: "notices",
                element: <Notices />,
              },
            ],
          },
          {
            path: "contact-us",
            element: <ContactUs />,
          },
          {
            path: "privacy-policy",
            element: <PrivacyPolicy />,
          },
          {
            path: "terms",
            element: <Terms />,
          },
        ],
      },
    ],
  },
]);

const retailerRoute = createBrowserRouter([
  {
    path: "/",
    element: <RootLayout />,
    children: [
      { index: true, element: <Navigate to="/app/product/category" /> },
      {
        path: "/auth",
        element: <Auth />,
        children: [
          {
            path: "login",
            element: <RetailLogin />,
          },
          {
            path: "signup",
            element: <RetailRegister />,
          },
          {
            path: "forgot-password",
            element: <ForgotPassword />,
          },
        ],
      },
      {
        path: "/app",
        element: "",
        children: [
          {
            path: "product",
            element: <RetailerProductPage />,
            children: [
              {
                path: "category",
                element: <RetailerCategory />,
              },
              {
                path: "product-list/:id",
                element: <ProductList />,
              },
              {
                path: "products/:id",
                element: <Product />,
              },
              {
                path: "details/:id",
                element: <ProductDetails />,
              },
            ],
          },
          {
            path: "cart",
            element: <Cart />,
            children: [
              {
                path: "list",
                element: <CartList />,
              },
              {
                path: "checkout",
                element: <Checkout />,
              },
              {
                path: "payment-success",
                element: <PaymentSuccess />,
              },
              {
                path: "payment-failed",
                element: <PaymentFailed />,
              },
            ],
          },
          {
            path: "profile",
            element: <ProfilePages />,
            children: [
              {
                path: "user-details",
                element: <Profile />,
              },
              {
                path: "member-info",
                element: <MemberInfo />,
              },
              {
                path: "change-email",
                element: <EmailUpdate />,
              },
              {
                path: "change-password",
                element: <ChangePassword />,
              },
              {
                path: "order",
                element: <Orders />,
              },
              {
                path: "order/:id",
                element: <OrdersDetails />,
              },
              {
                path: "order-update/:id",
                element: <OrderUpdate />,
              },
              {
                path: "notices",
                element: <Notices />,
              },
            ],
          },
          {
            path: "contact-us",
            element: <ContactUs />,
          },
          {
            path: "user-guide",
            element: <HowToUse />,
          },
        ],
      },
    ],
  },
]);

export { userRoute, retailerRoute };
